const flowList = {
  data() {
    return {
      loading: false,
      typeId: 0,
      path: null,
      cates: []
    }
  },
  methods: {
    getFlowCates() {
      const query = {
        params: {
          caseType: this.caseId
        }
      }
      this.apiGet('bpm/types/side', query).then((res) => {
        if (res.code == 200) {
          _(res.data).forEach((res) => {
            res.selected = false
          })
          this.cates = res.data
        } else {
          _g.dealError(this, res)
        }
      })
    },
    switchTypeId(val) {
      if (this.typeId != val) {
        this.typeId = val
      }
    }
  }
}

export default flowList



// WEBPACK FOOTER //
// ./src/components/Flow/mixins/flowCommon.js